import { render } from "./BasicInfo.vue?vue&type=template&id=e4a272a2"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"
script.render = render

export default script